<template>
    <div class="Field__Component">
        <div><slot>
            <a target="_blank" :href="`${value}`">
                <b-icon pack="fa" icon="eye"></b-icon>
            </a>
        </slot></div>
    </div>
</template>

<script>
export default {
    name: 'FieldCustomerLink',
    props: ['value', 'item'],
};
</script>

<style scoped>
    .Field__Component a {
        text-decoration: underline;
        color: #0091ae !important;
        /* text-align: center; */
        /* display: block; */
    }
</style>
